import { guideSteps } from '@/mocks/homeData';

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.16em] text-secondary-700 uppercase">
            <i className="ri-route-line" aria-hidden="true" />
            How To Use
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            三步走：从进来到下次还能找到
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            不需要任何技巧，按下面的顺序做一次，之后每次访问都会变得很轻松。整套流程只花你一分钟。
          </p>
        </div>

        <ol className="mt-10 space-y-5 md:space-y-6">
          {guideSteps.map((step, index) => (
            <li
              key={step.id}
              className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-8 items-center rounded-lg border border-background-200 bg-background-100 p-4 md:p-6 animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className={`lg:col-span-5 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="w-full h-52 md:h-64 rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={step.image}
                    alt={`使用指南第 ${step.step} 步：${step.title}`}
                    title={`黑料地址使用指南 ${step.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className={`lg:col-span-7 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="flex items-center gap-3">
                  <span className="font-heading text-3xl md:text-4xl font-bold text-primary-300">{step.step}</span>
                  <span className="h-px flex-1 bg-background-300" aria-hidden="true" />
                </div>
                <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-700">{step.description}</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {step.points.map((point) => (
                    <li
                      key={point}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700 whitespace-nowrap"
                    >
                      <i className="ri-check-line text-accent-600" aria-hidden="true" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}